var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSuppliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Suppliers_-Blank-clickboard",
    "data-name": "Suppliers -Blank-clickboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 130.222,
    viewBox: "0 0 182 130.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M122.911,30c-11.668-.4-22.78-4.172-33.391-8.293S68.4,13.025,57.01,10.842c-7.325-1.4-15.7-1.6-21.6,2.318-5.681,3.786-7.516,10.3-8.5,16.355-.743,4.554-1.179,9.347.855,13.611,1.413,2.96,3.919,5.448,5.654,8.284,6.034,9.865,1.769,22.03-4.768,31.662-3.065,4.518-6.625,8.834-8.992,13.638s-3.461,10.328-1.39,15.243c2.052,4.868,6.943,8.516,12.241,11.085,10.761,5.219,23.436,6.712,35.805,7.559,27.372,1.871,54.888,1.062,82.332.249,10.157-.3,20.357-.6,30.348-2.174,5.549-.873,11.276-2.257,15.306-5.6a12.816,12.816,0,0,0,2.953-16.743c-5.747-8.924-21.634-11.139-25.656-20.714-2.21-5.271.059-11.141,3.274-16.029C181.76,59.1,193.314,49.9,193.921,37.916c.418-8.232-5.136-16.476-13.725-20.372-9-4.083-21.486-3.57-28.124,3.189C145.231,27.686,133.214,30.363,122.911,30Z",
    transform: "translate(-17.167 -9.921)",
    fill: "#2699fb",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_No_data_re_kwbl",
    transform: "translate(46.762 43.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M589.387,360.936H533.718a1.375,1.375,0,0,1-1.4-1.346V295.433a1.375,1.375,0,0,1,1.4-1.346h55.669a1.376,1.376,0,0,1,1.4,1.346V359.59A1.376,1.376,0,0,1,589.387,360.936Z",
    transform: "translate(-595.88 -108.901) rotate(-17)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M366.146,177.683h-23.84a2.052,2.052,0,0,0-2.049,2.049v52.984l-.273.083-5.848,1.791a1.094,1.094,0,0,1-1.365-.725l-17.4-56.822a1.093,1.093,0,0,1,.725-1.365l9.012-2.76,26.126-8,9.012-2.76a1.091,1.091,0,0,1,1.365.724l4.447,14.524Z",
    transform: "translate(-309.978 -158.258)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M379.964,163.362a1.232,1.232,0,0,1-1.176-.87l-1.76-5.747a1.229,1.229,0,0,1,.816-1.536l24.035-7.358a1.231,1.231,0,0,1,1.536.816l1.76,5.747a1.231,1.231,0,0,1-.816,1.536l-24.035,7.358A1.227,1.227,0,0,1,379.964,163.362Z",
    transform: "translate(-363.204 -145.897)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983",
    "data-name": "Ellipse 983",
    cx: 2.732,
    cy: 2.732,
    r: 2.732,
    transform: "translate(22.433 1.9)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_984",
    "data-name": "Ellipse 984",
    cx: 1.73,
    cy: 1.73,
    r: 1.73,
    transform: "translate(23.435 2.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M589.387,360.936H533.718a1.375,1.375,0,0,1-1.4-1.346V295.433a1.375,1.375,0,0,1,1.4-1.346h55.669a1.376,1.376,0,0,1,1.4,1.346V359.59A1.376,1.376,0,0,1,589.387,360.936Z",
    transform: "translate(-502.313 -274.572)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M579.653,351.736H533.479a1.162,1.162,0,0,1-1.161-1.161V295.248a1.162,1.162,0,0,1,1.161-1.161h46.174a1.163,1.163,0,0,1,1.161,1.161v55.327A1.163,1.163,0,0,1,579.653,351.736Z",
    transform: "translate(-497.327 -272.203)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M635.184,264.557H610.048a1.231,1.231,0,0,1-1.229-1.229v-6.011a1.231,1.231,0,0,1,1.229-1.229h25.136a1.231,1.231,0,0,1,1.229,1.229v6.011a1.231,1.231,0,0,1-1.23,1.229Z",
    transform: "translate(-563.376 -239.394)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_985",
    "data-name": "Ellipse 985",
    cx: 2.732,
    cy: 2.732,
    r: 2.732,
    transform: "translate(56.508 11.639)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_986",
    "data-name": "Ellipse 986",
    cx: 1.664,
    cy: 1.664,
    r: 1.664,
    transform: "translate(57.576 12.707)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSuppliers);
export default __webpack_public_path__ + "static/media/no-suppliers.9db38a64381bec56642a78f26b79d114.svg";
export { ForwardRef as ReactComponent };